function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * @license Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module typing/deleteobserver
 */
import Observer from '@ckeditor/ckeditor5-engine/src/view/observer/observer';
import DomEventData from '@ckeditor/ckeditor5-engine/src/view/observer/domeventdata';
import BubblingEventInfo from '@ckeditor/ckeditor5-engine/src/view/observer/bubblingeventinfo';
import { keyCodes } from '@ckeditor/ckeditor5-utils/src/keyboard';
import env from '@ckeditor/ckeditor5-utils/src/env';
/**
 * Delete observer introduces the {@link module:engine/view/document~Document#event:delete} event.
 *
 * @extends module:engine/view/observer/observer~Observer
 */

var DeleteObserver = /*#__PURE__*/function (_Observer) {
  _inherits(DeleteObserver, _Observer);

  var _super = _createSuper(DeleteObserver);

  /**
   * @inheritDoc
   */
  function DeleteObserver(view) {
    var _this;

    _classCallCheck(this, DeleteObserver);

    _this = _super.call(this, view);
    var document = view.document;
    var sequence = 0;
    document.on('keyup', function (evt, data) {
      if (data.keyCode == keyCodes.delete || data.keyCode == keyCodes.backspace) {
        sequence = 0;
      }
    });
    document.on('keydown', function (evt, data) {
      var deleteData = {};

      if (data.keyCode == keyCodes.delete) {
        deleteData.direction = 'forward';
        deleteData.unit = 'character';
      } else if (data.keyCode == keyCodes.backspace) {
        deleteData.direction = 'backward';
        deleteData.unit = 'codePoint';
      } else {
        return;
      }

      var hasWordModifier = env.isMac ? data.altKey : data.ctrlKey;
      deleteData.unit = hasWordModifier ? 'word' : deleteData.unit;
      deleteData.sequence = ++sequence;
      fireViewDeleteEvent(evt, data.domEvent, deleteData);
    }); // `beforeinput` is handled only for Android devices. Desktop Chrome and iOS are skipped because they are working fine now.

    if (env.isAndroid) {
      document.on('beforeinput', function (evt, data) {
        // If event type is other than `deleteContentBackward` then this is not deleting.
        if (data.domEvent.inputType != 'deleteContentBackward') {
          return;
        }

        var deleteData = {
          unit: 'codepoint',
          direction: 'backward',
          sequence: 1
        }; // Android IMEs may change the DOM selection on `beforeinput` event so that the selection contains all the text
        // that the IME wants to remove. We will pass this information to `delete` event so proper part of the content is removed.
        //
        // Sometimes it is only expanding by a one character (in case of collapsed selection). In this case we don't need to
        // set a different selection to remove, it will work just fine.

        var domSelection = data.domTarget.ownerDocument.defaultView.getSelection();

        if (domSelection.anchorNode == domSelection.focusNode && domSelection.anchorOffset + 1 != domSelection.focusOffset) {
          deleteData.selectionToRemove = view.domConverter.domSelectionToView(domSelection);
        }

        fireViewDeleteEvent(evt, data.domEvent, deleteData);
      });
    }

    function fireViewDeleteEvent(originalEvent, domEvent, deleteData) {
      var event = new BubblingEventInfo(document, 'delete', document.selection.getFirstRange());
      document.fire(event, new DomEventData(document, domEvent, deleteData)); // Stop the original event if `delete` event was stopped.
      // https://github.com/ckeditor/ckeditor5/issues/753

      if (event.stop.called) {
        originalEvent.stop();
      }
    }

    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(DeleteObserver, [{
    key: "observe",
    value: function observe() {}
  }]);

  return DeleteObserver;
}(Observer);
/**
 * Event fired when the user tries to delete content (e.g. presses <kbd>Delete</kbd> or <kbd>Backspace</kbd>).
 *
 * Note: This event is fired by the {@link module:typing/deleteobserver~DeleteObserver observer}
 * (usually registered by the {@link module:typing/delete~Delete delete feature}).
 *
 * @event module:engine/view/document~Document#event:delete
 * @param {module:engine/view/observer/domeventdata~DomEventData} data
 * @param {'forward'|'delete'} data.direction The direction in which the deletion should happen.
 * @param {'character'|'word'} data.unit The "amount" of content that should be deleted.
 * @param {Number} data.sequence A number describing which subsequent delete event it is without the key being released.
 * If it's 2 or more it means that the key was pressed and hold.
 * @param {module:engine/view/selection~Selection} [data.selectionToRemove] View selection which content should be removed. If not set,
 * current selection should be used.
 */


export { DeleteObserver as default };